// extracted by mini-css-extract-plugin
export var sliderRange = "_cq-2";
export var sliderRoot = "_cq-0";
export var sliderThumb = "_cq-3";
export var sliderTrack = "_cq-1";